export default "__VITE_ASSET__BZ1JQHsm__"